<template>
  <div>
    <!-- ヘッダ -->
    <comHeaderAnyone :propScreenTitle="screenTitle"></comHeaderAnyone>
    <!-- メイン -->
    <v-main>
      <v-container fluid>
        <!-- メッセージエリア -->
        <v-alert border="bottom" colored-border type="warning" elevation="2">
          パスワードの再設定用のURLが記載されたメールをお送りしました。<br />
          メールに記載されたページにアクセスし、画面に表示されている認証コードを入力してください。<br />
        </v-alert>
        <br />

        <v-alert
          icon="mdi-shield-lock-outline"
          prominent
          text
          type="info"
          elevation="2"
        >
          <p class="text-h6">認証コード</p>
          <p class="text-h3">{{ dispAuthCd }}</p>
          <p class="text-h8">発行日時：{{ dispCreateDateTime }}</p>
          <p class="text-h8">認証コードの有効期間は発行日時から{{dispValidMinutes}}分です。</p>
        </v-alert>
        
      </v-container>
    </v-main>

    <!-- フッター(なし) -->
  </div>
</template>

<script>
export default {
  name: "AuthConfirm",
  data() {
    return {
      screenTitle: "パスワード再設定",
      dispCreateDateTime: "",
      dispAuthCd: "",
      dispValidMinutes:""
    };
  },
  created() {
   this.initialize();
 },
  methods: {
    /*
    * 初期表示
    */
    initialize: function(){
      this.dispAuthCd = this.$route.params['authCd'];
      this.dispCreateDateTime = this.$route.params['reqDatetime'];
      this.dispValidMinutes = this.$route.params['validMinutes'];
    },
    CloseWindow() {
      window.close();
      return false;
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 750px) {
}
</style>
